module.exports = "//static.hsappstatic.net/marketplace-ui-common/static-1.1043/img/callout-blobs.svg"